
<template>
    <div
        :id="id"
        class="lni-c-warehouse-retaliation"
    >
        <lni-spinner
            v-if="isLoading"
            :id="`${id}_spinner`"
            :inline="false"
        />
        <form
            v-show="!isLoading && !hasError"
            :novalidate="true"
        >
            <h1 class="lni-u-heading--1 lni-u-mb3">
                {{ getData('heading') }}
            </h1>
            <LniRetaliationComplaints
                :id="`${id}_complaint`"
            />
            <lni-radios
                :id="`${id}_other-agency`"
                class="lni-u-mb2"
                :isColumn="false"
                :changeAction="`${id}/toggleOtherAgency`"
            />
            <lni-collapse
                :id="`${id}_other-agency_collapse`"
                class="lni-u-mb2 lni-u-reading-width--max"
                :visible="false"
                :speed="2000"
            >
                <lni-input-textarea
                    :id="`${id}_other-agency_details`"
                    :fullWidth="true"
                    :limit="2000"
                    :required="true"
                    :labelBefore="true"
                />
            </lni-collapse>
            <LniRetaliationContact
                :id="`${id}_contact`"
            />
            <LniRetaliationEmployer
                :id="`${id}_employer`"
            />
            <LniRetaliationDocuments
                :id="`${id}_documents`"
            />
            <div class="lni-u-pt3 lni-u-bt lni-u-b--subtle">
                <lni-checkbox
                    :id="`${id}_certify`"
                    :required="true"
                />
                <lni-button
                    :id="`${id}_submit`"
                    class="lni-u-mb2 lni-c-button --primary"
                    :errorContainerId="`${id}_error-container`"
                    :clickAction="['validateForm', `${id}/submit`]"
                />
                <div class="lni-u-reading-width--max">
                    <lni-error-container
                        :id="`${id}_error-container`"
                        class="lni-u-mt2"
                        :errorsCollectedFrom="trackedErrors"
                    />
                </div>
            </div>
        </form>
        <div
            role="status"
            class="lni-u-reading-width--max"
        >
            <div v-if="!isLoading && hasError">
                <h1 class="lni-u-heading--2">
                    There was an error.
                </h1>
                <p>{{ errorMessage }}</p>
                <details class="lni-u-mt4">
                    <summary>Technical details:</summary>
                    {{ errorDetails }}
                </details>
                <lni-informational-messages
                    :id="`${id}_post-submission-errors`"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LniRetaliationForm',
    data() {
        return {
            errorDetails: null,
        };
    },
    computed: {
        data() {
            return this.$store.getters['appState/data'];
        },
        isLoading() {
            return this.$store.state.appState?.isLoading;
        },
        hasError() {
            return this.$store.state.appState?.hasError;
        },
        errorMessage() {
            return this.$store.state.appState?.initializeError;
        }
    },
    async mounted() {
        const payload = {
            oneLni: this.$oneLni,
            sourceId: this.id,
        };
        await this.$store.dispatch('call', payload).then(async (response) => {
            if (response instanceof Error) {
                this.errorDetails = response;
                return;
            } else {
                await this.$store.dispatch(`${this.id}/initialize`, payload);
                await this.$store.dispatch(`${this.id}_complaint/initialize`, payload);
                await this.$store.dispatch(`${this.id}_contact/initialize`, payload);
                await this.$store.dispatch(`${this.id}_employer/initialize`, payload);
                await this.$store.dispatch(`${this.id}_documents/initialize`, payload);
            }
        });

    },
    methods: {
        getData(name) {
            return this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
        },
    },
}
</script>